// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as PipelineExtended } from '../../../assets/icons/extended/entities/pipeline.svg?react';
import { createIcons } from '../../Icon';
const PipelineIcon = /* @__PURE__ */ createIcons('Pipeline', {
    extended: PipelineExtended
});
PipelineIcon.supportedTypes = ['extended'];
PipelineIcon.category = 'entities';
export default PipelineIcon;
